import type { PortalAudience } from '@/access/portalAccess.types';
import type {
  JobsViewInput,
  DaySequencesFetchWhen,
} from '@/modules/jobs/jobs.viewInput';

export type JobDrawerWorkerSection = 'assign' | 'assignedReadOnly' | 'none';

export type JobDrawerView = {
  audience: PortalAudience;
  sections: {
    details: boolean;
    rate: boolean;
    worker: JobDrawerWorkerSection;
    timesheets: boolean;
  };
  actions: {
    showClientName: boolean;
    allowUnassignWorker: boolean;
    showWorkerPayRate: boolean;
  };
  query: {
    applications: { fetch: boolean };
    daySequences: { fetchWhen: DaySequencesFetchWhen };
    assignedWorker: { fetch: boolean };
  };
};

export const getJobDrawerView = ({
  access,
  clientsCanSeePayRates,
}: JobsViewInput): JobDrawerView => {
  const { audience, isClientPortal, canManageTenantJobs } = access;

  return {
    audience,
    sections: {
      details: true,
      rate: canManageTenantJobs,
      worker: canManageTenantJobs
        ? 'assign'
        : isClientPortal
          ? 'assignedReadOnly'
          : 'none',
      timesheets: true,
    },
    actions: {
      showClientName: !isClientPortal,
      allowUnassignWorker: canManageTenantJobs,
      showWorkerPayRate: canManageTenantJobs || clientsCanSeePayRates,
    },
    query: {
      applications: { fetch: canManageTenantJobs },
      daySequences: { fetchWhen: 'drawerOpen' },
      assignedWorker: { fetch: true },
    },
  };
};
